module.exports = __webpack_public_path__ + "img/ad_cn2.1830fec1.png";